<div class="spinner__container">
  <div class="spinner__icon">
    <img src="assets/images/icon.png">
  </div>
  <div *ngIf="showText" class="spinner__text">{{text}}</div>
</div>
